import { EMPTY_OBJECT } from '../../../constants/common'
import { SymbolCounter } from '../../SymbolCounter'
import { useSelectFocusContext } from '../Select.hooks'

import * as styles from './InputSelectControlIndicatorsSymbolCounter.module.css'

function InputSelectControlIndicatorsSymbolCounter({
  className = styles.InputSelectControlIndicatorsSymbolCounter,
  ...restProps
} = EMPTY_OBJECT) {
  const { focused } = useSelectFocusContext()

  return focused ? <SymbolCounter {...restProps} className={className} /> : null
}

export default InputSelectControlIndicatorsSymbolCounter
